<script setup>
import { SpeckleProjectSearch } from '@haskoning/vue-speckle'
</script>

<template>
  <v-card border="opacity-35 sm" variant="text">
    <v-card-title>Speckle project</v-card-title>
    <v-card-subtitle>
      Select the Speckle project that the calculations in this project are sent to.
    </v-card-subtitle>

    <div class="pa-4">
      <SpeckleProjectSearch />
    </div>
  </v-card>
</template>
